export const AVAILABLE = 'AVAILABLE';
export const UNAVAILABLE_OFFICE_CLOSED = 'UNAVAILABLE_OFFICE_CLOSED';
export const UNAVAILABLE_BUSY = 'UNAVAILABLE_BUSY';
export const OVERLAPING_PATH = ['onboarding', 'checkout'];
